import { act } from "react-test-renderer";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ExistingRegularCryDispatcher } from "./Variable";
import { RegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";

export interface ExistingRegularCryStaticState {
    actionType: ActionType;
    isLoading: boolean;
    contribution: RegularDrawdown;
}

export class ExistingRegularCryStatic extends BaseStore<ExistingRegularCryStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ExistingRegularCryDispatcher, (actionData) => 
        this.onExistingRegularCryResponse(actionData))
    }
    
    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }
    protected getDefaultState(): ExistingRegularCryStaticState {
        return { actionType: ActionType.Loading, isLoading: true, contribution: null }
    }

    public getExistingRegularCry(): RegularDrawdown {
        return this.getState().contribution;
    }

    private onExistingRegularCryResponse(actionData): void {
        switch(actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.ActionType, contribution: actionData.payload});
                break;
            default:
                this.setState({ actionType: actionData.actionType, contribution: null, isLoading: true });
                break;
        }
    }
}